import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function LogoutIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.302 15.191l1.254 1.253L16 12l-4.444-4.444-1.254 1.253 2.294 2.302H4v1.778h8.596l-2.294 2.302zM18.222 4H5.778C4.79 4 4 4.8 4 5.778v3.555h1.778V5.778h12.444v12.444H5.778v-3.555H4v3.555C4 19.2 4.791 20 5.778 20h12.444C19.2 20 20 19.2 20 18.222V5.778C20 4.8 19.2 4 18.222 4z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Logout.js.map